import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { Spinner } from '../../atoms/Spinner';
import { useTestId } from '../../hooks';
import { forwardRefWithName } from '../../utils';
import { themes } from './themes';
const DEFAULT_THEME = 'obsidian';
export const buttonStyles = {
    large: {
        height: 'h-14',
        padding: 'px-6',
        text: 'text-base font-normal',
    },
    medium: {
        height: 'h-12',
        padding: 'px-5',
        text: 'text-base font-normal',
    },
    small: {
        height: 'h-10',
        padding: 'px-4',
        text: 'text-base font-normal',
    },
    mini: {
        height: 'h-8',
        padding: 'px-3',
        text: 'txt-light-heading6',
    },
};
function ButtonComponent(props, ref) {
    const { children, theme = DEFAULT_THEME, outlined = false, className, icon, disabled = false, underline = false, circular = false, type = 'button', size = 'mini', testId = 'button', onClick, loading } = props, buttonProps = __rest(props, ["children", "theme", "outlined", "className", "icon", "disabled", "underline", "circular", "type", "size", "testId", "onClick", "loading"]);
    const tid = useTestId(testId, buttonProps);
    const handleClick = disabled || loading ? undefined : onClick;
    const themeConfig = themes[theme][outlined ? 'outlined' : 'default'];
    const sizeStyles = buttonStyles[size];
    const classList = twMerge('box-border', 'flex', 'items-center', 'select-none', 'leading-6', 'text-primary', 'border', 'rounded-[4px]', 'font-roobert', 'justify-center', 'whitespace-nowrap', underline && 'underline underline-offset-4 hover:no-underline', disabled || loading ? 'opacity-50 cursor-default pointer-events-none' : 'cursor-pointer', themeConfig.idle.join(' '), circular ? 'rounded-full' : '', circular && icon ? 'h-12 w-12 px-3' : [sizeStyles.height, sizeStyles.padding].join(' '), sizeStyles.text, themeConfig.hover.join(' '), themeConfig.active.join(' '), className);
    return (_jsxs("button", Object.assign({ ref: ref, className: classList, onClick: handleClick, disabled: disabled, type: type }, tid(), buttonProps, { children: [loading || icon ? (_jsx("div", Object.assign({ "data-testid": "button-icon", className: children ? 'mr-1' : '' }, tid('icon'), { children: loading ? _jsx(Spinner, Object.assign({ theme: "black" }, tid('spinner'), { size: 4 })) : icon }))) : null, children && (_jsx("div", Object.assign({ className: "relative" }, tid('content'), { children: children })))] })));
}
export const Button = forwardRefWithName(ButtonComponent);
//# sourceMappingURL=Button.js.map